import _ from 'lodash';
import axios from 'axios';

import store from '../stores/store';
import { FILTERS_SET_CATEGORIES } from '../actions/filtersAction';
import { INSIDERS_SET_ONLINE, INSIDERS_LAST_NOTIFICATION } from '../actions/insidersAction';
import { LUSER_INIT, checkFollowedIntegrity } from '../actions/luserAction';
import { THREADS_INIT, THREADS_REFRESH } from '../actions/threadsAction';
import { clearAlert, error as errorAlert, notification } from '../actions/alertAction';
import { setLocale } from '../actions/settingsAction';
import { DEFAULT_LOCALE, getTranslator } from '../../locales';

export const CHAT_INIT = 'chat-init';
export const CHAT_LOAD = 'chat-load';
export const CHAT_CLOSE_UI = 'chat-close-user-interface';
export const CHAT_LOADED = 'chat-loaded';
export const CHAT_RECONNECT = 'chat-reconnect';
export const CHAT_DISCONNECT = 'chat-disconnect';
export const CHAT_NB_CONNECTED_USERS = 'chat-nb-connected-users';
export const CHAT_MOBILE_PANEL = 'chat-mobile-panel';
export const CHAT_INIT_ERROR = 'chat-error';
export const CHAT_TOGGLE_NOTIFICATION_FORM = 'insiders-toggle-notification-form';
export const CHAT_TOGGLE_ASK_FORM = 'chat-toggle-ask-form';
export const CHAT_WILL_END = 'chat-will-end';
export const CHAT_ENDED = 'chat-ended';
export const CHAT_SOUND_PLAY = 'chat-sound-play';
export const CHAT_SOUND_PLAYED = 'chat-sound-played';
export const WELCOME_SURVEY_TOGGLE_NOTIFICATION_PANEL = 'welcome-survey-panel';
export const WELCOME_SURVEY_SUBMIT = 'welcome-survey-submit';

// Welcome survey
export const SURVEY_MAX_ANSWERS = 3;
export const SURVEY_ANSWER_OTHER_VALUE = 8; //where a text field is attached

export function init(payload) {
  console.log('@@@@@@@ INIT @@@@@@@', payload);
  return { type: CHAT_INIT, payload };
}

export function load(options = { reconnect: false }) {
  const data = {};
  const liveChatId = store.getState().chat.id;
  const serverUrl = store.getState().chat.serverUrl;

  if (!liveChatId || !serverUrl) {
    console.error('Undefined liveChatId or undefined serverUrl', { liveChatId, serverUrl });
    return errorAlert('CHAT_INIT_FAILED');
  }

  return async function(dispatch) {
    axios.get(
      serverUrl + '/sessions/' + liveChatId + '?' + (new Date().getTime()),
      { withCredentials: true })
      .then(async (response) => {
        console.log('*** From chatInitAction.load() ***');

        if (response.status == 200) {
          console.log('*** LOCALE ***', response.data.locale);
          const appLocale = response.data.locale || DEFAULT_LOCALE;

          await dispatch(setLocale(appLocale));

          if (
            !_.isEmpty(response.data.closed) &&
            response.data.closed === true
            ) {
              dispatch(errorAlert('CHAT_CLOSED_DETAILS'));
          } else {
            const actions = {
              'you': LUSER_INIT,
              // threads: THREADS_INIT,
              categories: FILTERS_SET_CATEGORIES,
              connectedUsersCount: CHAT_NB_CONNECTED_USERS,
              insidersOnline: INSIDERS_SET_ONLINE,
              lastInsiderNotification: INSIDERS_LAST_NOTIFICATION
            };

            if (options.reconnect) {
              actions.threads = THREADS_REFRESH;
            } else {
              actions.threads = THREADS_INIT;
            }

            _.map(actions, (dispatcherType, k) => {
              dispatch({type: dispatcherType, payload: response.data[k]});

              delete response.data[k];
            });

            dispatch(clearAlert());
            dispatch(soundPlay('welcome'));
            dispatch({ type: CHAT_LOAD, payload: response.data });
            dispatch(checkFollowedIntegrity());
          }
        } else {
          console.error('Load session response is not 200', { response });
          dispatch(errorAlert('CHAT_INIT_FAILED'));
        }
      })
      .catch((err) => {
        if (err.response && parseInt(err.response.status, 10) === 401) {
          dispatch(errorAlert('NOT_LOGGED_IN'));
        } else {
          console.error('Error while fetching the session', { err });
          dispatch(errorAlert('CHAT_INIT_FAILED'));
        }
      });
  }
}

export function reconnect(payload) {
  console.log('chatInitAction : reconnect()', payload);
  return { type: CHAT_RECONNECT, payload };
}

export function closeUI() {
  return { type: CHAT_CLOSE_UI };
}

export function setMobilePanel(panelToOpen) {
  let mobilePanels = store.getState().chat.mobilePanels;
  let currentSet = false;

  _.map(mobilePanels, (panelClassName, panel) => {
    let panelClass = 'panel_out';

    if (panel == panelToOpen) {
      currentSet = true;
      panelClass = 'panel_in';
    } else {
      panelClass = panelClass + ' ' + (!currentSet ? 'prev' : 'next');
    }
    mobilePanels[panel] = panelClass;
  });

  const isAskFormOpened = (panelToOpen == 'thread_form');
  const isNotificationFormOpened = (panelToOpen == 'insider_form');

  return {
    type: CHAT_MOBILE_PANEL,
    payload: {
      mobilePanels,
      mobileSelected: panelToOpen,
      isAskFormOpened,
      isNotificationFormOpened
    }
  };
}

export function updateConnectedUsers(nb) {
  return { type: CHAT_NB_CONNECTED_USERS, payload: nb };
}

export function toggleInsiderForm(isNotificationFormOpened) {
  return { type: CHAT_TOGGLE_NOTIFICATION_FORM, isNotificationFormOpened };
}

export function EndTheChat() {
  return { type: CHAT_WILL_END };
}

export function chatDidEnd() {
  const t = getTranslator();

  return dispatch => {
    dispatch(
      notification(t.t('The Live Chat has ended. You can still ask our Insiders questions on the PathMotion platform.'))
    );
    setTimeout(() => {
      dispatch({ type: CHAT_ENDED });
      window.location.href = store.getState().chat.endRedirectUrl;
    }, 1000)
  };
}

export function soundPlay(sound) {
  if (store.getState().settings.sound == 'on') {
    return { type: CHAT_SOUND_PLAY, sound };
  }
  return { type: false };
}

export function soundPlayed() {
  return { type: CHAT_SOUND_PLAYED };
}

export function toggleWelcomeSurveyPanel() {
  return { type: WELCOME_SURVEY_TOGGLE_NOTIFICATION_PANEL };
}

export function submitWelcomeSurvey(data) {
  return { type: WELCOME_SURVEY_SUBMIT, data };
}




// WEBPACK FOOTER //
// ./src/redux/actions/chatInitAction.jsx